import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';

import { ListModule } from '../global/components/list.module';
import { PageLayoutModule } from '../global/page-layout';
import { LanguageModule } from '../global/language';

import { BattlePage, AddForcePage, UnitStatusPage, GetIconPipe, StatusIndicatorComponent } from './components';
import { getCombinedBattleReducers } from './service/reducer';
import { StatusIndicatorsComponent } from './components/status-indicators/status-indicators.component';

export const BATTLE_COMPONENTS = [
    BattlePage,
    AddForcePage,
    UnitStatusPage,
    StatusIndicatorsComponent,
    StatusIndicatorComponent,
    GetIconPipe
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild([]),
        IonicModule,
        ListModule,
        PageLayoutModule,
        StoreModule.forFeature('Battle', getCombinedBattleReducers()),
        TranslateModule,
        LanguageModule
    ],
    declarations: [...BATTLE_COMPONENTS],
    exports: [...BATTLE_COMPONENTS],
    providers: []
})
export class ArmyBuilderBattleModule {}
